export const SET_MESSAGE_REPORTS_REQUESTED = 'SET_MESSAGE_REPORTS_REQUESTED';
export const setMessageReportsRequested = (messageReportsRequested) => (
    {
        type: SET_MESSAGE_REPORTS_REQUESTED,
        messageReportsRequested
    }
);

export const SET_DATE_REPORTS_REQUESTED = 'SET_DATE_REPORTS_REQUESTED';
export const setDateReportsRequested = (dateReportsRequested) => (
    {
        type: SET_DATE_REPORTS_REQUESTED,
        dateReportsRequested
    }
);

export const SET_FILTER_ROUTE_REPORT_PRODUCTS = 'SET_FILTER_ROUTE_REPORT_PRODUCTS';
export const setfFilterRouteReportProducts = (filterRouteReportProducts) => (
    {
        type: SET_FILTER_ROUTE_REPORT_PRODUCTS,
        filterRouteReportProducts
    }
);

export const SET_FILTER_SELECTED_USER_HISTORY_CLIENT = 'SET_FILTER_SELECTED_USER_HISTORY_CLIENT';
export const setFilterSelecteduserHistoryClient = (filterSelecteduserHistoryClient) => (
    {
        type: SET_FILTER_SELECTED_USER_HISTORY_CLIENT,
        filterSelecteduserHistoryClient
    }
);

